module.exports = __webpack_public_path__ + "img/logo.472232ce.png";